// Utils
import { isSameObject } from './isSameObject';
import { applyChanges } from './applyChanges';
import { detectChangesBetweenValues } from '../changeDetection';
import { removeDeletedObjectsFromChanges } from './removeDeletedObjectsFromChanges';
/**
 * Performs a 3 way merge for identified objects. Where the right values have the lefts changes
 * (relative to base) applied on it.
 *
 * @param {Identifiable<T>} left
 * @param {Identifiable<T>} base
 * @param {Identifiable<T>} right
 * @param {MergeOptions} [options={}]
 *
 * @return {Identifiable<T>}
 */
export var merge = function (left, base, right, options) {
    if (options === void 0) { options = {}; }
    if (!isSameObject(base, right)) {
        // Then we have a replacement, no resolving here
        // @todo consider perhaps we should throw an error here instead?
        return right;
    }
    // For performance do strict checks, to determine if the are any changes
    if (base === right) {
        return left;
    }
    if (base === left) {
        return right;
    }
    var rightChanges = detectChangesBetweenValues(base, right);
    // If right has no changes, use left
    if (Object.keys(rightChanges).length === 0)
        return left;
    var leftChanges = detectChangesBetweenValues(base, left);
    // If left has no changes, use right
    if (Object.keys(leftChanges).length === 0)
        return right;
    // Remove changes references to deleted objects from leftChanges, since they no longer exist in right
    var changes = removeDeletedObjectsFromChanges(leftChanges, rightChanges);
    return applyChanges(right, changes, options);
};
//# sourceMappingURL=merge.js.map